import { Flame, Instagram, Youtube, Facebook } from "lucide-react";
import { CHECKOUT_URL } from "@/lib/site";

const SOCIALS = [
  ["instagram", Instagram, "Instagram"],
  ["youtube", Youtube, "YouTube"],
  ["facebook", Facebook, "Facebook"],
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-950 border-t border-slate-900 text-slate-400 pt-16 pb-28 md:pb-12">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="flex flex-col md:flex-row items-start justify-between gap-10">
        <div className="max-w-sm">
          <div className="flex items-center gap-2 font-display font-extrabold text-lg text-white mb-4">
            <span className="w-9 h-9 rounded-xl bg-blue-600 text-white flex items-center justify-center"><Flame size={20} /></span>
            Bryan Lee <span className="text-blue-400">Fitness</span>
          </div>
          <p className="text-sm leading-relaxed">Simple follow-along home workouts for busy, unmotivated people who want real fat-loss results — without the gym.</p>
        </div>
        <nav className="flex flex-col gap-3 text-sm font-semibold" aria-label="Footer navigation">
          <a data-testid="footer-link-trial" href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Start Free Trial</a>
          <a data-testid="footer-link-pricing" href="#pricing" className="hover:text-white transition-colors">Pricing</a>
          <a data-testid="footer-link-faq" href="#faq" className="hover:text-white transition-colors">FAQ</a>
          <a data-testid="footer-link-results" href="#results" className="hover:text-white transition-colors">Results</a>
        </nav>
        <div>
          <p className="text-sm font-bold text-white mb-4">Follow Bryan</p>
          <div className="flex gap-3">
            {SOCIALS.map(([id, Icon, label]) => (
              <a key={id} data-testid={`social-${id}`} href="#" aria-label={label} className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between gap-4 text-xs">
        <p>© {new Date().getFullYear()} Bryan Lee Fitness. All rights reserved.</p>
        <p className="max-w-md">Disclaimer: Results shown are not typical and vary by individual. Always consult a physician before starting any exercise program.</p>
      </div>
    </div>
  </footer>
);
